import { render, staticRenderFns } from "./PointCard.vue?vue&type=template&id=d1596796&scoped=true&"
import script from "./PointCard.vue?vue&type=script&lang=js&"
export * from "./PointCard.vue?vue&type=script&lang=js&"
import style0 from "./PointCard.vue?vue&type=style&index=0&id=d1596796&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1596796",
  null
  
)

export default component.exports